module.exports = __webpack_public_path__ + "static/media/image026.3f9f7b12.jpg";